/* eslint-disable react/no-array-index-key */
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { useState } from 'react';
import glassUpgrade from '../../../../assets/images/glass-upgrade.png';
import glass from '../../../../assets/images/glass.png';
import upgrade3 from '../../../../assets/images/plan-hot.svg';
import upgrade1 from '../../../../assets/images/upgrade1.svg';
import upgrade2 from '../../../../assets/images/upgrade2.svg';
import Text from '../../../../assets/styles/Text';
import CheckoutModal from '../../../../components/CheckoutModal';
import PopUpPlan from '../../../../components/PopUpPlan';
import * as styles from './styles';

export default function Upgrade({ upgrade }) {
  const [pagment, setPagment] = useState(false);
  const [checkout, setCheckout] = useState(false);
  const { name, price, subName, type, description, signature } = upgrade;

  const benefits = description.split(',');

  return (
    <styles.Gruop>
      <PopUpPlan
        type={type}
        show={pagment}
        onClose={() => setPagment(false)}
        signature={signature}
        upgrade={type}
      />

      <CheckoutModal
        show={checkout}
        onClose={() => setCheckout(false)}
        plan={upgrade}
        isUpgrade
      />

      {type !== 2 && <Text.Span>Melhoria</Text.Span>}

      <styles.Container $type={type}>
        <styles.Background
          $type={type}
          $glass={type === 3 ? glassUpgrade : glass}
        >
          {type !== 2 && (
            <styles.Name>
              <Text.H2>{name}</Text.H2>
              <Text.H3>{subName}</Text.H3>
            </styles.Name>
          )}

          {type === 2 && (
            <div className="bottom">
              <styles.Name>
                <Text.H2>{name}</Text.H2>
                <Text.H3>{subName}</Text.H3>
              </styles.Name>

              <Text.Span>Boost de 01 Hora</Text.Span>
            </div>
          )}

          {type === 1 && <img src={upgrade1} alt="plan" />}
          {type === 2 && <img src={upgrade2} alt="plan" />}
          {type === 3 && <img src={upgrade3} alt="plan" />}
        </styles.Background>

        <styles.Body>
          <styles.Ul>
            {benefits.map((benefit, index) => (
              <li key={index}>{parse(benefit)}</li>
            ))}
          </styles.Ul>

          <styles.Signature>
            <Text.H2>R$ {price.toFixed(2).replace('.', ',')}</Text.H2>
            {signature && <Text.Span $bold>Mensal</Text.Span>}
          </styles.Signature>

          <styles.GroupButton
            $type={type}
            $glass={type === 3 ? glassUpgrade : glass}
          >
            {type === 3 && (
              <button
                type="button"
                className="info"
                onClick={() => setPagment(true)}
              >
                <Text.Span $bold>VER PRÉVIA DE VISUALIZAÇÃO </Text.Span>
              </button>
            )}
            <button
              type="button"
              className="buy"
              onClick={() => setCheckout(true)}
            >
              <Text.H2>
                {!signature ? 'Compre agora' : 'Quero essa assinatura'}
              </Text.H2>
            </button>
          </styles.GroupButton>
        </styles.Body>
      </styles.Container>
    </styles.Gruop>
  );
}

Upgrade.propTypes = {
  upgrade: PropTypes.shape().isRequired,
};
